<template>
    <div class="card-details" v-if="show">
        <div v-if="isEnabled && !hasConfigError">
            <div class="card-element-container" v-show="!isLoading">
                <label v-if="hasLabel">Card Number</label>
                <div ref="stripeElement"></div>

                <div v-if="isLoading">
                    <div class="text-center">
                        <v-progress-circular
                        indeterminate
                        color="blue"
                        ></v-progress-circular>
                    </div>
                </div>

                <br/>
                
                <div ref="cardErrors" role="alert"></div>
                <v-alert
                :value="hasError"
                type="error"
                color="red"
                >
                {{errorMessage}}
                </v-alert>
            </div>
        </div>
        
        <v-alert
        :value="hasConfigError"
        type="error"
        color="red"
        >
        {{errorMessage}}
        </v-alert>
    </div>
</template>

<style lang="css" scoped>
    
</style>

<script>
/**
 * Define the style of the stripe element
 * 
 * `base`: for default state design configuration
 * `invalid`: the error state where the input of the user is invalid. This will override the defined style in the `base`
 */
var CardFieldStyle = {
    base: {
        color: '#32325d',
        fontFamily: '"Open Sans", sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '12px',
        '::placeholder': {
            // placeholder style configuration here
            color: '#aab7c4',
            fontWeight: 500
        },
    },
    invalid: {
        color: '#fa755a',
    }
};


/**
 * CARD DETAILS COMPONENT
 * 
 *  Connects to Stripe using publishable key
 *  Creates Stripe Elements
 *  Returns stripe token 
 * 
 */
export default {
    props: {
        hasLabel: {
            default: false,
            type: Boolean
        },
        publishableKey: {
            default: null,
            type: String
        }
    },
    data: function () {
        return {
            stripe: undefined,                                      // Stripe Instance
            elements: undefined,                                    // Stripe Elements handler
            style: CardFieldStyle,                                 // Stripe Elements style configuration
            card: undefined,                                        // Stripe Elements container

            hasError: false,                                       // Error state
            errorMessage: "",                                      // Error message
            hasConfigError: false,                                  // Define Configuration (Stripe Element) Errors

            isEnabled: true,                                       // Display state

            token: undefined,                                       // Stripe Token
            show: true,
            isLoading: false,                                      // Loading state
        }
    },
    methods: {
        onMount() {
            this.loadKey(this.publishableKey)
        },
        /**
         * Validates and loads publishable key
         * @param {String} key Stripe publishable key
         */ 
        loadKey: function(key){
            
            if( key !== undefined && key !== null && key !== "" ){
                this.stripe = Stripe(key);
                this.stripeInit()
            } else {
                this.errorMessage = "Stripe Key not set";
                this.hasConfigError = true;
            }
        },
        /**
         * Initializes the Stripe Instance and card elements
         */
        stripeInit: async function(){
            this.elements = this.stripe.elements()
            this.card = this.elements.create('card', { hidePostalCode: true, style: this.style })
            this.mountCard();
        },
        /**
         * Destroys the Stripe input and returns the response
         * @param {Object} token Stripe response
         * @returns response<{state: Bolean, result: Object}>
         */
        stripeTokenHandler: function (token) {
            this.token = token;
            this.stripeInit();
            return { state: true, result: token };
        },

        /**
         * Sends request to Stripe to create stripe token
         */
        createToken: async function () {
            var vm = this;
            if(this.isEnabled){
                this.isLoading = true;
                return await this.stripe.createToken(this.card).then(function (result) {
                    vm.isLoading = false;
                    return result.error                                 // determine response type
                        ? { state: false, result: result.error.message }
                        : vm.stripeTokenHandler(result.token);
                });
            }
            else {
                this.reset();
                return { state: false, result: "Token already created" };
            }
        },

        /**
         * Resets the component fields and flash message
         */
        reset: function(){
            var vm = this;
            this.$nextTick(function(){
                vm.show = true;                                // displays the elements to the DOM
                vm.isEnabled = true;
                vm.$nextTick(function(){
                    vm.mountCard();
                })
            })
        },

        /**
         * Mounts the stripe card element to the DOM
         */
        mountCard: function(){
            var vm = this;
            
            try {
                var id = `fdca-card-element-${Math.random().toString(36).substring(7)}`
                this.$refs["stripeElement"].id = id
                this.card.mount(`#${id}`);
            } catch (error) {
                // --> the element has been removed
                console.error(error.message)
            }
            
            /**
             * Handles the Stripe input fields `change` events
             * @param {Event} event Stripe input event
             */
            this.card.addEventListener('change', function (event) {
                if (event.error) {
                    vm.errorMessage = event.error.message;
                    vm.hasError = true;
                } else {
                    vm.errorMessage = "";
                    vm.hasError = false;
                }
            });
        }
    },
    mounted: function () {
    }
}
</script>